import React from 'react'
import "./Subtotal.css";
import { NumericFormat } from "react-number-format";
import { useStateValue } from './StateProvider';
import { getBasketTotal } from './reducer';
import { useHistory } from 'react-router-dom';

function Subtotal() {
    const history=useHistory();
    const [{user,basket},dispatch]=useStateValue();
    return (
        <div className="subtotal">
            <NumericFormat
            renderText={(value)=>(
                <>
                <p>
            Subtotal({basket.length} items):<strong>{value}</strong>
                </p>
                <small className="subtotal__gift">
                    <input type="checkbox"/>This order contain gift
                </small>
                </>
            )}
            decimalScale={2}
            value={getBasketTotal(basket)}
            displayType={"text"}
            thousandSeparator
            prefix={"₹"}
            />
           
                <button disabled={getBasketTotal(basket)<1} onClick={user?e=>history.push('/payment'):e=>history.push('/login')}> Proceed to checkout</button>
            
            
        </div>
    )
}

export default Subtotal
